import * as ReactService from "@intech/react-service";
import { ProtocoloEntidade } from "@entidades";

class Comprovantes extends ReactService.BaseService {
  constructor() {
    super("Comprovantes");
  }

  Buscar = () =>
    this.CreateRequest<ProtocoloEntidade[]>(ReactService.RequestType.POST, `Buscar`);

  BuscarPorOid = (oid: number) =>
    this.CreateRequest<ProtocoloEntidade>(ReactService.RequestType.POST, `BuscarPorOid/${oid}`);

}

export const ComprovantesService = new Comprovantes();
